import { Button } from '@mantine/core';
import { ReactNode } from 'react';

interface StepperTabButtonProps {
    label: ReactNode;
    isSelected: boolean;
    onClick: () => void;
    rightIcon?: ReactNode;
    disabled?: boolean;
    title?: string;
}

export default function StepperTabButton({
    label,
    isSelected,
    onClick,
    rightIcon,
    disabled = false,
    title,
}: StepperTabButtonProps) {
    const getRootClassName = () => {
        if (disabled) return 'step-button-disabled';
        return isSelected ? 'step-button-selected' : 'step-button';
    };

    const getLabelClassName = () => {
        if (disabled) return 'step-button-label-disabled';
        return isSelected ? 'step-button-label-selected' : 'step-button-label';
    };

    return (
        <Button
            disabled={disabled}
            rightIcon={rightIcon}
            classNames={{
                root: getRootClassName(),
                label: getLabelClassName(),
            }}
            onClick={onClick}
            title={title}
        >
            {label}
        </Button>
    );
}
